<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-03-04 10:21:26
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-13 15:46:24
-->

<template>
  <div class="page-list">
    <!-- 搜索栏 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>年份&nbsp;:</label>
          <el-date-picker v-model="params.params.year" value-format="yyyy" type="year" placeholder="请选择年份">
          </el-date-picker>
        </div>
        <div class="page-search-item">
          <label>养殖场&nbsp;:</label>
          <el-select v-model="params.params.baseId" filterable @change="getGroupList(params.params.baseId)"
            placeholder="请选择养殖场">
            <el-option label="全部养殖场" value=""></el-option>
            <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>区域&nbsp;:</label>
          <el-select v-model="params.params.groupId" filterable placeholder="请选择区域">
            <el-option label="全部区域" value=""></el-option>
            <el-option v-for="item in groupList" :key="item.groupId" :label="item.groupName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖造次&nbsp;:</label>
          <el-select v-model="params.params.periodId" filterable placeholder="请选择养殖造次">
            <el-option label="全部养殖造次" value=""></el-option>
            <el-option v-for="item in periodList" :key="item.periodId" :label="item.periodName" :value="item.periodId">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="params.params.breedId" filterable placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option v-for="item in breedList" :key="item.breedId" :label="item.breedName" :value="item.breedId">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reset">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="page-list-content">
      <!-- 列表 -->
      <div class="page-list-title">
        <div><i class="title-icon"></i>年度经营目标完成情况明细表-养成</div>
        <div>单位 : {{ orgName }}</div>
        <div>年份 : {{ showYear }}年</div>
        <div>
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="switch-table" @click="switchTable">汇总</span>
          <span @click="exportTable">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"></el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="groupName" label="区域"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="periodName" label="养殖造次">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedName" label="品种"> </el-table-column>
        <el-table-column label="投苗量(公斤)">
          <el-table-column prop="putNumberTarget" label="计划">
          </el-table-column>
          <el-table-column prop="putNumber" label="实际"> </el-table-column>
          <el-table-column prop="putNumberComplete" label="完成比例%">
          </el-table-column>
        </el-table-column>
        <el-table-column label="产量(万尾)">
          <el-table-column prop="harvestWeightTarget" label="计划">
          </el-table-column>
          <el-table-column prop="harvestWeight" label="实际"> </el-table-column>
          <el-table-column prop="harvestWeightComplete" label="完成比例%">
          </el-table-column>
        </el-table-column>
        <el-table-column label="产值(万元)">
          <el-table-column prop="harvestMoneyTarget" label="计划">
          </el-table-column>
          <el-table-column prop="harvestMoney" label="实际"> </el-table-column>
          <el-table-column prop="harvestMoneyComplete" label="完成比例%">
          </el-table-column>
        </el-table-column>
        <el-table-column label="利润(万元)">
          <el-table-column prop="harvestProfitTarget" label="计划">
          </el-table-column>
          <el-table-column prop="harvestProfit" label="实际"> </el-table-column>
          <el-table-column prop="harvestProfitComplete" label="完成比例%">
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  searchTargetAnalysisGroupList,
  exportTargetAnalysisGroupList,
  getGroupConditions,
  getPeriodConditions,
  getBreedConditions,
} from "../ym-annals-target/annals-target-service";
import {
  queryBaseDataListByRole,
  queryBaseGroupList,
} from "@/api/middle/common";
import Page from "@/utils/methods/page";
export default {
  name: "detail",
  data() {
    return {
      baseList: [], // 养殖场列表
      orgName: "",
      PageDisplay: true, // 展开收起
      showYear: "", // 显示的年份
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "periodName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      params: {
        currPage: 1,
        pageSize: 10,
        orderBy: "desc",
        orderByName: "groupName",
        params: {
          baseId: "",
          year: localStorage.getItem("m-year") ? localStorage.getItem("m-year") : this.$moment().year().toString(), // 年份
          groupId: "",
          orgId: "", // 顶级机构id
          periodId: "",
          breedTypeId: "",
          breedId: "",
          pageType: "0", // 1汇总 0明细
          breedTypeClass: "fish", // fish养成 egg育苗
        },
      },
      exportParams: {}, // 导出参数
      tableData: [],
      groupList: [], // 公司列表
      periodList: [], // 品类列表
      breedList: [], // 品种列表
    };
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
    this.params.params.orgId = localStorage.getItem("orgId");
    this.orgName = localStorage.getItem("orgName");
    // 养殖场
    queryBaseDataListByRole().then((res) => {
      if (res.code == "0000") {
        this.baseList = res.data;
      }
    });
    // 获取造次列表
    getPeriodConditions(
      this.params.params.orgId,
      this.params.params.breedTypeClass
    ).then((res) => {
      if (res.code == "0000") {
        this.periodList = res.data;
      }
    });
    // 获取品种列表
    getBreedConditions(
      this.params.params.orgId,
      this.params.params.breedTypeClass
    ).then((res) => {
      if (res.code == "0000") {
        this.breedList = res.data;
      }
    });
    this.getPageList(); // 获取分页
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    // 根据养殖场获取区域
    getGroupList(baseId) {
      this.params.params.groupId = "";
      this.groupList = [];
      if (!baseId) return
      this.params.params.groupId = "";
      queryBaseGroupList({
        baseId,
      }).then((res) => {
        if (res.code == "0000") {
          this.groupList = res.data;
        }
      });
    },
    // 切换汇总表
    switchTable() {
      this.$emit("getPageType", "summary");
    },
    // 查询
    search() {
      this.getPageList();
    },
    // 重置
    reset() {
      this.params.params.baseId = "";
      this.params.params.year = localStorage.getItem("m-year") ? localStorage.getItem("m-year") : this.$moment().year().toString();
      this.params.params.groupId = "";
      this.params.params.periodId = "";
      this.params.params.breedId = "";
      this.getPageList();
    },
    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.groupName === "合计") {
        return "heji-row";
      }
    },
    // 显示的单位-年-月-日
    showListData() {
      if (this.params.params.year) {
        this.showYear = this.params.params.year;
      }
    },
    // 获取育苗明细分页
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      searchTargetAnalysisGroupList(this.params).then((res) => {
        if (res.code == "0000") {
          this.tableData = res.data.list;
          this.showListData();
          this.exportParams = JSON.parse(JSON.stringify(this.params.params));
        }
        loading.close();
      });
    },
    // 导出
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        this.exportParams.fileName = "养成年度经营目标完成情况明细";
        Page.exportDatas(exportTargetAnalysisGroupList(), this.exportParams);
      });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
};
</script>

<style lang="less" scoped></style>